import {
  attributesFieldKeys,
  audienceAttributeLabels,
  searchableAttributes
} from '../../../lib/attributes'

export const fieldKeyOptions: AttributeRuleFieldKeyOptions =
  attributesFieldKeys.map(key => ({
    value: key,
    label: audienceAttributeLabels[key],
    isSearchable: searchableAttributes.includes(key)
  }))
